__turbopack_context__.v({
  "className": "g3RmGa_className",
  "variable": "g3RmGa_variable",
});
